module.exports = __webpack_public_path__ + "assets/img/on-roof.5a7d530a.webp";